"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetRotationCommand = exports.SetScaleCommand = exports.SetPositionCommand = exports.RemoveObjectCommand = exports.AddObjectCommand = void 0;
// eslint-disable-next-line import/no-cycle
const AddObjectCommand_1 = __importDefault(require("./AddObjectCommand"));
exports.AddObjectCommand = AddObjectCommand_1.default;
// eslint-disable-next-line import/no-cycle
const RemoveObjectCommand_1 = __importDefault(require("./RemoveObjectCommand"));
exports.RemoveObjectCommand = RemoveObjectCommand_1.default;
// eslint-disable-next-line import/no-cycle
const setPositionCommand_1 = require("./setPositionCommand");
Object.defineProperty(exports, "SetPositionCommand", { enumerable: true, get: function () { return setPositionCommand_1.SetPositionCommand; } });
// eslint-disable-next-line import/no-cycle
const setScaleCommand_1 = require("./setScaleCommand");
Object.defineProperty(exports, "SetScaleCommand", { enumerable: true, get: function () { return setScaleCommand_1.SetScaleCommand; } });
// eslint-disable-next-line import/no-cycle
const setRotationCommand_1 = require("./setRotationCommand");
Object.defineProperty(exports, "SetRotationCommand", { enumerable: true, get: function () { return setRotationCommand_1.SetRotationCommand; } });
